import { render, staticRenderFns } from "./RTabs.vue?vue&type=template&id=7f359473&scoped=true"
import script from "./RTabs.vue?vue&type=script&lang=js"
export * from "./RTabs.vue?vue&type=script&lang=js"
import style0 from "./RTabs.vue?vue&type=style&index=0&id=7f359473&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f359473",
  null
  
)

export default component.exports